/** Media kit comercial / patrocinio de TNO Business (propuesta genérica). */
export const TNO_BUSINESS_PATROCINIO_PATH = '/patrocinio-tno-business';
export const TNO_BUSINESS_PATROCINIO_URL = 'https://ads.tnonetwork.com/patrocinio-tno-business';
